<template>
  <div class="page">
    <div class="product" v-if="type == 1">
      <div class="product-img">
        <van-image
          fit="cover"
          width="100%"
          height="100%"
          :src="zxdata.avatar"
          alt=""
        />
      </div>
      <div class="product-info">
        <div class="product-name">{{ zxdata.username }}</div>
        <div class="product-title">{{ zxdata.title }}</div>
        <div class="product-price">￥{{ zxdata.price }}</div>
      </div>
    </div>
    <template v-if="type == 2">
      <div class="product" v-for="(item, index) in teachers" :key="index">
        <div class="product-img">
          <img
            v-if="item.id == 0"
            style="width:100%;height:100%"
            src="../../assets/zx/syetem.png"
            alt=""
          />
          <van-image
            v-else
            fit="cover"
            width="100%"
            height="100%"
            :src="item.avatar"
            alt=""
          />
        </div>
        <div class="product-info " @click="celitem(item)">
          <div class="product-name">{{ item.name }}</div>
          <!-- <div class="product-title">{{ zxdata.title }}</div> -->
          <div class="product-info1">
            <div class="product-price">￥{{ item.price }}</div>
            <div
              class="check"
              :class="item.checked ? 'radio-check' : 'radio'"
            ></div>
          </div>
        </div>
      </div>
    </template>
    <div class="product" v-if="type == 3">
      <div class="product-img">
        <van-image
          fit="cover"
          width="100%"
          height="100%"
          :src="zxdata.thumb"
          alt=""
        />
      </div>
      <div class="product-info">
        <div class="product-name">{{ zxdata.username }}</div>
        <div class="product-title">{{ zxdata.title }}</div>
        <div class="product-price">￥{{ zxdata.price }}</div>
      </div>
    </div>
    <div class="line"></div>

    <div class="payment-info">
      <div class="title">支付信息</div>
      <div class="payment-op">
        <div class="payment-op-t">订单金额</div>
        <div class="payment-op-price">￥{{ orderMoney }}</div>
      </div>
      <div
        class="payment-op"
        @click="showCoupon = true"
        v-if="couponList.length"
      >
        <div class="payment-op-t">优惠券：{{ coupon.title }}</div>
        <i class="iconfont icon-a-LeftArrow"></i>
      </div>
      <!-- <div class="payment-op">
        <div class="payment-op-t">金币:{{ gold }}</div>
        <div>
          <van-switch
            v-model="sShow"
            active-color="#4fd9d5"
            inactive-color="#dcdee0"
          />
        </div>
      </div> -->
      <div class="payment-op">
        <div>
          支付方式
        </div>
        <RadioGroup v-model="radio" direction="horizontal">
          <!-- <Radio name="1" checked-color="#4fd9d5">微信</Radio> -->
          <Radio name="2" checked-color="#4fd9d5">支付宝</Radio>
          <Radio name="3" checked-color="#4fd9d5" style="margin-right:0"
            >金币</Radio
          >
        </RadioGroup>
      </div>
      <a class="target" :href="href" target="_blank" ref="target"></a>
    </div>
    <div class="line"></div>
    <div v-if="type == 1 && night" class="serbox">
      <img src="../../assets/i.png" class="i" alt="" />
      <div>
        此刻为夜间订单，老师可能不会马上回复，请仔细考虑后 再购买服务。
      </div>
    </div>
    <popup
      v-model="showCoupon"
      round
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="popup-title">选择优惠券</div>
      <coupon :list="couponList" @use="selectCoupon" />
    </popup>
    <div class="footer">
      <div class="money">
        <p>
          实付金额: <span>￥{{ flag ? fprice : price }}</span>
        </p>
      </div>
      <div class="confirmpay" @click="payment">确认支付</div>
    </div>
  </div>
</template>

<script>
/**
@description:订单确认
@createTime:2021-09-23 
@create:wq
1金币=0.1元
s = 2 问答订单 s=1 买课
*/
import { Popup, RadioGroup, Radio } from "vant";
import coupon from "@/views/mine/coupon/couponComponent";
import wx from "jweixin-module";
import { number } from "echarts";
import { getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: { Popup, coupon, Radio, RadioGroup },
  data() {
    return {
      night: false,
      showCoupon: false,
      couponList: [],
      coupon: "",
      type: "",
      radio: "2",
      zxdata: "",
      teachers: [],
      orderID: "",
      gold: 0,
      allGold: JSON.parse(localStorage.getItem("user")).gold,
      changeCoupon: false,
      sShow: false,
      fprice: 0,
      flag: false,
      href: "http://h5.keyice.club/alipay/",
      duration: 0,
      orderId: "",
    };
  },
  computed: {
    // 实付金额
    price: {
      get() {
        //咨询
        let price = 0;
        if (this.type == 1 || this.type == 3) {
          if (this.coupon) {
            const cp_p = this.zxdata.price * 100;
            const coupon_p = this.coupon.price * 100;
            let p = (cp_p - coupon_p) / 100;
            price = p >= 0 ? p : 0;
          } else {
            let p = this.zxdata.price;
            price = p >= 0 ? p : 0;
          }
        }
        //问答
        if (this.type == 2) {
          let price = 0;
          this.teachers.forEach((item) => {
            if (item.checked) {
              price = (price * 100 + item.price * 100) / 100;
            }
          });
          if (this.coupon) {
            const couponPrice = this.coupon.price;
            price = (price * 100 - couponPrice * 100) / 100;
            return price > 0 ? price : 0;
          } else {
            return price > 0 ? price : 0;
          }
        }
        if (this.sShow) {
          price = price - this.gold / 10 >= 0 ? price - this.gold / 10 : 0;
        }
        this.fprice = price;
        return price;
      },
    },
    //订单金额
    orderMoney() {
      if (this.type == 2) {
        let money = 0;
        this.teachers.forEach((item) => {
          money = (money * 100 + item.price * 100) / 100;
        });
        // if (money * 10 <= Number(this.allGold)) {
        //   this.gold = Math.ceil(money * 10);
        // } else {
        //   this.gold = Number(this.allGold);
        // }

        return money;
      }
      if (this.type == 3 || this.type == 1) {
        return this.zxdata.price;
      }
      return 0;
    },
  },
  watch: {
    coupon(bf, af) {
      if (bf != af) {
        this.changeCoupon = true;
        //金币
        // if (!this.sShow) {
        //   return;
        // }
        // let p = this.orderMoney - this.coupon.price;
        // p = p >= 0 ? p : 0;
        // this.allGold = Number(this.allGold);
        // if (p > 0 && this.allGold != 0) {
        //   this.gold = Math.ceil(Math.min(p * 10, this.allGold));
        // } else {
        //   this.gold = 0;
        // }
      } else {
        this.changeCoupon = false;
      }
    },
    sShow(b) {
      this.flag = b;
      if (b) {
        let g = this.gold / 10;
        if (this.type == 2) {
          this.fprice = this.price - g >= 0 ? this.price - g : 0;
        } else {
          this.fprice = this.price;
        }
      }
    },
  },
  mounted() {},
  created() {
    let code = getQueryString("code");
    console.log(code, "----------------------code-------------------");
    if (!code) {
      if (this.$route.query && this.$route.query.s) {
        this.type = this.$route.query.s;
        // this.coupons();
        // this.zxdata = JSON.parse(localStorage.getItem("order"));
        // console.log(this.zxdata, "this.zxdata");
        // console.log(this.orderMoney, "orderMoney");
        //金币
        // if (this.type == 1 || this.type == 3) {
        //   if (this.orderMoney * 10 <= Number(this.allGold)) {
        //     this.gold = Math.ceil(this.orderMoney * 10);
        //   } else {
        //     this.gold = Number(this.allGold);
        //   }
        // }

        // if (this.type == 2) {
        //   this.teachers = JSON.parse(localStorage.getItem("st"));
        // }
        // if (this.type == 1) {
        //   this.getTime();
        // }
        // this.jsSdk();
      }
    } else {
      let state = getQueryString('state');
      // let state = "1orid1247#/orderConfirm";
      // console.log(state,'------------------------------888-');
      state = state.substring(0, state.indexOf("#/"));
      // console.log(state,'-------------------------------');
      let orderId = state.split("orid");
      this.type = orderId[0];
      this.orderId = orderId[1];

      if (code) {
        this.getopenid(code);
      }
    }
    this.coupons();
    this.zxdata = JSON.parse(localStorage.getItem("order"));
    if (this.type == 2) {
      this.teachers = JSON.parse(localStorage.getItem("st"));
    }
    if (this.type == 1) {
      this.getTime();
    }
    this.jsSdk();
  },
  methods: {
    getTime() {
      this.api.otherData().then((res) => {
        // this.couponList = res.data;
        let st = res.data.startTime;
        let et = res.data.endTime;
        let date = new Date();
        let t =
          date.getFullYear() +
          "/" +
          (date.getMonth() + 1) +
          "/" +
          date.getDate();
        st = new Date(t + " " + st).getTime();
        et = new Date(t + " " + et).getTime();
        let nowTime = date.getTime();
        // let nowTime = 1641950982000;
        if (nowTime <= et || nowTime >= st) {
          this.night = true;
        } else {
          this.night = false;
        }
      });
    },
    selectCoupon(item) {
      // console.log(item);
      this.coupon = item;
      this.showCoupon = false;
    },
    celitem(item) {
      item.checked = !item.checked;
    },
    coupons() {
      this.api.coupons({ type: this.type }).then((res) => {
        this.couponList = res.data;
      });
    },

    payment() {
      // if (this.orderID) return this.pay(this.orderID);

      const obj = {};
      if (this.type == 1) {
        obj.type = this.type;
        obj.id = this.zxdata.id;
        obj.coupons_id = this.coupon ? this.coupon.id : "";
        // obj.isGold = this.sShow ? 1 : 0;
        // obj.gold = this.gold;
      }
      if (this.type == 2) {
        obj.type = this.type;
        obj.id = this.zxdata.id ? this.zxdata.id.id : 0;
        obj.coupons_id = this.coupon ? this.coupon.id : "";
        obj.answers = obj.id == 0 ? this.zxdata.answers : "";
        obj.pcid = this.zxdata.pcid.id;
        obj.name = this.zxdata.name;
        obj.sex = this.zxdata.sex;
        obj.birthday = this.zxdata.birthday.split("-").join(" ");
        obj.lunar = this.zxdata.lunar;
        obj.time = this.zxdata.time;
        obj.num = this.zxdata.num;
        obj.tids = [];
        this.teachers.map((item, index) => {
          if (item.checked) {
            obj.tids.push(item.id);
          }
        });
        obj.tids = obj.tids.join(",");
        // obj.isGold = this.sShow ? 1 : 0;
        // obj.gold = this.gold;
      }
      if (this.type == 3) {
        obj.type = this.type;
        obj.id = this.zxdata.id;
        obj.coupons_id = this.coupon ? this.coupon.id : "";
        // obj.isGold = this.sShow ? 1 : 0;
        // obj.gold = this.gold;
      }
      obj.isGold = 0;
      if (this.radio == 3) {
        obj.isGold = 1;
      }
      console.log(this.allGold, "allGold--");
      if (
        ((this.allGold != 0 &&
          Number(this.orderMoney) > Number(this.allGold) / 10) ||
          this.allGold == 0) &&
        this.radio == 3
      ) {
        this.Toast("金币不足");
        return;
      }
      this.Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      this.api.order(obj).then((res) => {
        this.orderID = res.data.id;
        if (this.radio == 2) {
          //支付宝
          let order_sn = res.data.order_sn;
          this.href = this.href + order_sn;
          this.Toast.clear();
          // let target = this.$refs.target;
          // target.setAttribute("href", this.href);
          // target.click();
          window.location.href = this.href;
        } else if (this.radio == 1) {
          //微信
          this.pay(res.data.id, 1);
        } else if (this.radio == 3) {
          //金币
          this.Toast.clear();
          this.pay(res.data.id);
          // this.Toast.success("支付成功");
          setTimeout(() => {
            if (this.type == 1) {
              this.$router.replace("orderzx");
            } else if (this.type == 2) {
              this.$router.replace("orderaw");
            } else if (this.type == 3) {
              this.$router.replace("kcOrder");
            }
          }, 2000);
        }
      });
    },
    getopenid(code) {
      this.api.getOpenid({ opcode: code }).then((res) => {
        this.api.pay({ id: this.orderId, openid: res.data }).then((res) => {
          this.payParams = res;
          console.log(res);
          if (res.data.systemPay == 1) {
            this.Toast.clear();
            this.Toast.success("支付成功");
            setTimeout(() => {
              if (that.type == 1) {
                that.$router.replace("orderzx");
              } else if (that.type == 2) {
                that.$router.replace("orderaw");
              } else if (that.type == 3) {
                that.$router.replace("kcOrder");
              }
            }, 1500);
            return;
          }
          this.Toast.clear();
          this.wxPayFn(res);
        });
      });
    },

    wxPayFn(res) {
      let that = this;
      // 微信支付
      wx.chooseWXPay({
        timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
        package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: res.data.paySign, // 支付签名
        success: function() {
          that.Toast.clear();
          setTimeout(() => {
            let appid = localStorage.getItem("appid");
            let l = "";
            if (that.type == 1) {
              that.$router.replace("orderzx");
              // l = 'orderzx'
            } else if (that.type == 2) {
              that.$router.replace("orderaw");
              // l = 'orderzx'
            } else if (that.type == 3) {
              that.$router.replace("kcOrder");
              // l = 'orderzx'
            }
            // location.href =
          }, 2000);
          // 支付成功后的回调函数
        },
        fail: () => {
          this.Toast.clear();
          this.Toast("取消支付");
        },
      });
    },

    pay(id, t) {
      if (t == 1) {
        //微信支付
        this.api.getAppid().then((res) => {
          console.log(res.data);
          let appid = res.data;
          const url =
            location.origin +
            location.pathname +
            "?appid=" +
            appid +
            "#/orderConfirm";
          const redirect_uri = encodeURIComponent(url);
          let f = `${this.type}orid${id}`;
          console.log(f);
          // return
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${f}#wechat_redirect`;
        });
        return;
      }
      const that = this;
      this.api.pay({ id }).then((res) => {
        this.payParams = res;
        console.log(res);
        if (res.data.systemPay == 1) {
          this.Toast.clear();
          this.Toast.success("支付成功");
          setTimeout(() => {
            if (that.type == 1) {
              that.$router.replace("orderzx");
            } else if (that.type == 2) {
              that.$router.replace("orderaw");
            } else if (that.type == 3) {
              that.$router.replace("kcOrder");
            }
          }, 1500);
          return;
        }
        this.Toast.clear();
        this.wxPayFn();
      });
    },

    jsSdk() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let url = "";
      if (isiOS) {
        url = window.location.href.split("#")[0];
      } else {
        url = window.location.href;
      }
      this.api.jsSdk({ url }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
        });
        wx.ready(function() {
          console.log("===========");
          wx.error((res) => {
            console.log(res);
          });
          // TODO
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  width: 100%;
  height: 0.2rem;
  background: #f8f8f8;
}

.product {
  display: flex;
  align-items: center;
  margin: 0 0.4rem;
  padding: 0.3rem 0;
}
.product-img {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.2rem;
  overflow: hidden;
}
.product-info1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.product-info1 {
  .check {
    margin-top: 0.2rem;
  }
}
.product-info {
  flex: 1;
  margin-left: 0.25rem;
  .product-name {
    font-size: 0.32rem;
    font-weight: bold;
    color: #333333;
  }
  .product-title {
    font-size: 0.32rem;
    color: #34c290;
    margin-top: 0.1rem;
  }
  .product-price {
    font-size: 0.34rem;
    font-weight: bold;
    color: #f05468;
    margin-top: 0.2rem;
  }
}

.payment-info {
  margin-top: 0.38rem;
  .title {
    font-size: 0.32rem;
    color: #333333;
    padding-left: 0.3rem;
    font-weight: bold;
  }
  .payment-op {
    height: 1.08rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    padding: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .payment-op-t {
      font-size: 0.3rem;
      color: #333333;
    }
    .payment-op-price {
      font-size: 0.32rem;
      font-weight: bold;
      color: #333333;
    }
    i {
      font-size: 12px;
      color: #dbdbdb;
    }
    &:last-child {
      border: none;
    }
  }
}
.page {
  padding-bottom: 100px;
}
.footer {
  height: 60px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.3rem;
  box-shadow: 0px 0px 20px 0px rgba(181, 181, 181, 0.2);
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .money {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    span {
      font-size: 19px;
      font-weight: bold;
      color: #d40c1f;
    }
  }
  .confirmpay {
    width: 150px;
    height: 44px;
    background: #4fd9d5;
    border-radius: 22px;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.popup-title {
  font-size: 0.32rem;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin: 0.4rem 0;
}
.serbox {
  padding: 0.29rem;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  line-height: 1;
  .i {
    width: 0.28rem;
    height: 0.28rem;
    display: block;
    margin-top: 0.05rem;
    margin-right: 0.1rem;
  }
  div {
    color: #f05468;
    flex: 1;
    font-size: 0.26rem;
    line-height: 0.35rem;
    word-break: break-all;
  }
}
</style>
